import { useQuery } from "@tanstack/react-query";
import { config } from "./config";

const useTranslationQuery = (language: string) =>
  useQuery({
    queryKey: ["translations", language],
    queryFn: async () => {
      const response = await fetch(
        `${config.SID_ASSET_DETAILS_GW_BASE_URL}/v1/translations/${language}?system=${config.I18N_SYSTEM}`,
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch translations`);
      }

      return (await response.json()) as Record<string, string>;
    },
    // We need to do this because we don't want to refetch the translations every time we change the language
    staleTime: Infinity,
  });

export default useTranslationQuery;
